
export default class ExportReportingTrimestrielDto {
    trimestreId;
    trimestreIdFin;
}